export const rechargeLimitInput = 'recharge-limit-input';
export const temporarySelfExclusionInput = 'temporary-self-exclusion-input';
export const permanentSelfExclusionActive = 'permanent-self-exclusion-active';
export const amountPlayedNotificationActive = 'permanent-self-exclusion-active';

export const mapPayloadKeyToFieldName = {
  selflimitation: rechargeLimitInput,
  period: temporarySelfExclusionInput,
};
export const MONTHLY_RECHARGE_TYPE = 2;
export const WEEKLY_RECHARGE_TYPE = 1;
export const PERMANENT_SELF_EXCLUSION_TYPE = 2;
export const TEMPORARY_SELF_EXCLUSION_TYPE = 1;
export const AMOUNT_PLAYED_NOTIFICATION_ID = 7;

export enum PlayResponsiblyViews {
  monthlyRechargeLimit = 0,
  temporarySelfExclusion = 1,
  permanentSelfExclusion = 2,
  amountPlayedNotification = 3,
  privacy = 4,
}

export const mapPlayResponsiblyViewToAnalyticsName = {
  [PlayResponsiblyViews.privacy]: 'PRIVACY',
  [PlayResponsiblyViews.monthlyRechargeLimit]: 'LIMITE_MENSILE',
  [PlayResponsiblyViews.amountPlayedNotification]: 'NOTIFICA_IMPORTO',
  [PlayResponsiblyViews.permanentSelfExclusion]: 'AUTOESCLUSIONE_PERMANENTE',
  [PlayResponsiblyViews.temporarySelfExclusion]: 'AUTOESCLUSIONE_TEMPORANEA',
};

export const mapPlayResponsiblyViewToAnalyticsModalPayload = Object.fromEntries(
  Object.entries(mapPlayResponsiblyViewToAnalyticsName).map(([key, value]) => [
    key,
    {
      pagename:
        key !== '4'
          ? `areaprivata:giocailgiusto:popup:${value}`
          : `areaprivata:preferenze:popup:`,
    },
  ]),
) as Record<PlayResponsiblyViews, { pagename: string }>;
